module.exports = __webpack_public_path__ + "static/img/14.939c62dd.jpg";